export const scrollLock = (lock) => {
  document.body.style.overflow = lock ? "hidden" : null;
};
